export function getChartRuntime(): any {
  const runtime = (globalThis as unknown as { Chart?: unknown }).Chart;
  if (!runtime) {
    throw new Error('Chart.js failed to load. Please check your connection and refresh.');
  }
  return runtime;
}

